import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import Header from '../../components/header';
import Head from '../../components/head';
import Footer from '../../components/footer';
import DiarioListar from '../../components/diario/listar';


function DiarioScreen () {
    return (
        <Fragment>
            <Head titulo="Diário Oficial Eletrônico do Município de Macuco"/>
            <Header />
            <Container>
                <DiarioListar />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default DiarioScreen;